import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import { stringIsNullOrEmpty } from '../../utils/strings';
import FlexGrid from '../layout/FlexGrid';

class Graph extends Component {
    render() {
        const { variant = 'two' } = this.props;

        if (variant === 'three') return this.renderThree();

        if (stringIsNullOrEmpty(variant) || variant === 'two') return this.renderTwo();

        if (variant === 'four') return this.renderFour();

        return <span>unknown modal variant {variant}</span>;
    }

    renderTwo() {
        const { children, title } = this.props;
        return (
            <div className="two">
                <div className="graph-title">
                    <p>{title}</p>
                </div>
                <FlexGrid variant="no-wrap">{children}</FlexGrid>
            </div>
        );
    }

    renderThree() {
        const { children, title } = this.props;
        return (
            <div className="three">
                <div className="graph-title">
                    <p>{title}</p>
                </div>
                <FlexGrid variant="no-wrap">{children}</FlexGrid>
            </div>
        );
    }

    renderFour() {
        const { children, title } = this.props;
        return (
            <div className="four">
                <div className="graph-title">
                    <p>{title}</p>
                </div>
                <FlexGrid className="full-height">{children}</FlexGrid>
            </div>
        );
    }
}
export default withStyles({})(Graph);
